import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

import {listingFormMessages} from './lineItemMessages';
import {useFormatMessage} from '../../../intl/intlHooks';

const NonQualifiedDiscount = () => {
    const formatMessage = useFormatMessage();
    return (
        <React.Fragment>
            <FaInfoCircle />
            {' '}
            <i>{formatMessage(listingFormMessages.promoNotQualified)}</i>
        </React.Fragment>
)};

export default NonQualifiedDiscount
